<template>
    <div class="flex-col">
        <div class="text-14-black33-b margin-top-16">{{label}}</div>
        <div class="flex margin-top-16 flex-row-center-jx  padding-h-16 height-32 border-eb-1 just-end">

            <el-dropdown v-if="distinctions && distinctions.length>0" @command="handleCommand($event,child)">
                      <span class="el-dropdown-link text-14-orangeFF margin-left-16">
                            添加财产类型
                          <i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="item" v-for="(item,index) in distinctions" :key="index">
                        {{item.label}}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

        </div>
        <div v-if="children.length>0">
            <div v-for="(item,count) in children" :key="count">
                <div class="propertyPiece">

                    <div v-for="(group,index) in item" :key="index">
                        <div
                                :is="groupView"
                                :group-data="group"
                                @groupChildrenChange="groupDataChange(group,$event)"/>
                    </div>
                    <i class="el-icon-error delPiece" @click="getDelProperty(item)"></i>
                </div>

            </div>
        </div>
    </div>
</template>

<script>


    export default {
        name: 'ConditionSpecialView',

        data() {
            return {
                label: "",
                distinctions: null,
                groupView: "",
                children: [],
                items: null
            }
        },
        props: {
            groupData: {
                type: Object,
                default() {
                    return null;
                },
            },
        },
        watch: {
            groupData: {
                handler(newValue) {
                    // 外部数据发生变化

                    this.analysisData(newValue);
                },
                immediate: true
            },
        },
        computed: {},
        mounted() {

            this.groupView = resolve => {
                require([`../../formGroupView`], resolve)
            }
            this.groupEssential = resolve => {
                require([`../../formView`], resolve)
            }
        },
        methods: {
            analysisData(newData) {
                let {label, key, value, opinions, items, type, repeatable, required, children} = newData;
                this.label = label
                this.distinctions = opinions;
                this.items = items
                this.children=children
            },
            handleCommand(addItem) {
                console.log(this.items, 5555555555555)

                let pitchUp = null
                let isExist = false
                if (this.children.length > 0) {
                    this.children.forEach(value => {
                        value.forEach(res => {
                            if (res.conditionValue === addItem.value) {
                                isExist = true
                            }
                        })
                    })
                }

                if (isExist) {
                    return
                }
                this.items.forEach(value => {
                    if (value.conditionValue === addItem.value) {
                        value.items.forEach(resItem=>{
                            if(resItem.value){
                                delete resItem.value
                            }
                        })
                        value.children = []
                        value.children.push(value.items)
                    }

                })
                pitchUp = this.items.filter(v => {
                    return v.conditionValue === addItem.value;
                });
                this.children.push(pitchUp)

            },
            groupDataChange(groupData, children) {
                groupData.children = children
                this.$emit('addTypeChange',this.children)
            },
            getDelProperty(item) {
                this.children.forEach((value, index) => {
                    value.forEach(interior => {
                        if (interior.key === item[0].key) {
                            this.children.splice(index, 1)
                        }

                    })
                })
            },
        }

    }
</script>

<style scoped lang="scss">
    .propertyPiece {
        border: 1px solid #EBEBEB;
        margin-top: 16px;
        position: relative;

        .delPiece {
            position: absolute;
            right: 0%;
            top: 16px;
            font-size: 20px;
            cursor: pointer;
        }
    }

    .just-end {
        justify-content: end;
    }

    .border-bottom-1 {
        border-bottom: 1px solid #EBEBEB;
    }
</style>
